import draggable from 'vuedraggable';
import store_config from "@/store/mods/parametres/config"
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import $ from 'jquery'

export default {
    name: 'manage-modele-examen',
    components: {
        draggable, VueEditor
    },
    props: {
        is_edit: {
            type: Boolean,
            default: false
        },
        mdl_toggler: Number,
        type_examen_id: Number,
        user_info: Object,
        champ_to_edit: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        selected_modele: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        }
    },
    data() {
        return {
            customToolbar: vueEditorToolbar,
            info_modele: {
                nom_modele: "",
                liste_champs: [
                    {
                        champ_id: 0,
                        champ: '',
                        type: '',
                        tmp_type_champ: '',
                        occurences: [],
                        tmp_occurence: '',
                        tmp_existing_occurences: [],
                        can_show_occurence: false,
                        is_required: 0,
                        default_content: ''
                    }
                ]
            },
            l_type_champs: [],
            modal_title: '',
            clip_loading: true,
            save_loading: false,
            can_show_editor: true,
            err_message: '',
        }
    },

    watch: {
        mdl_toggler() {
            if (this.is_edit === true) {
                this.modal_title = "Modifier le modèle d'examen"
            } else {
                this.modal_title = "Nouveau modèle d'examen"
            }

            this.info_modele = {
                nom_modele: "",
                liste_champs: [
                    {
                        champ_id: 0,
                        champ: '',
                        type: '',
                        tmp_type_champ: '',
                        occurences: [],
                        tmp_occurence: '',
                        tmp_existing_occurences: [],
                        can_show_occurence: false,
                        is_required: 0,
                        default_content: ''
                    }
                ]
            }
            this.$refs.mdl_exam_form.reset()
            this.clearError()
            this.onTypeCertifChange('1')

            if (this.is_edit === true) {
                this.autoFillFields()
            }
        },
    },
    
    computed: {
        type_champs() {
            return this.$store.getters["type_champs"];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },
    },

    mounted() {
        // Liste type de champs
        this.$store.dispatch("getTypeChamps").then(() => {
            this.l_type_champs = this.type_champs.filter(item => item.champ === 'Editeur de texte');
        })

        this.getCertifClipBoard()
    },

    methods: {
        clearError() {
            this.err_message = ''

        },

        getCertifClipBoard() {
            this.clip_loading = true
            this.$store.dispatch("getListeTypeMixData", 'certif_placeholder').then(() => {
                this.clip_loading = false
            })
        },

        addField() {
            this.info_modele.liste_champs.push(
                {
                    champ_id: 0,
                    champ: '',
                    type: '',
                    tmp_type_champ: '',
                    occurences: [],
                    tmp_occurence: '',
                    can_show_occurence: false,
                    is_required: 0,
                    default_content: ''
                }
            )

            setTimeout(() => {
                this.onTypeCertifChange('1')
            }, 500);
        },

        removeField(index) {
            this.info_modele.liste_champs.splice(index, 1)
        },

        autoFillFields() {
            this.info_modele.nom_modele = this.selected_modele.libelle

            this.info_modele.liste_champs = [
                {
                    champ_id: this.champ_to_edit.champ_id,
                    champ: this.champ_to_edit.champ,
                    type: this.champ_to_edit.type_champ_id,
                    tmp_type_champ: ''+this.champ_to_edit.type_champ_id+'.'+this.champ_to_edit.type_champ,
                    occurences: [],
                    tmp_occurence: '',
                    tmp_existing_occurences: [],
                    can_show_occurence: false,
                    is_required: this.champ_to_edit.is_required,
                    default_content: this.champ_to_edit.default_content
                }
            ]
            
        },

        async copyToClipboard(char, event) {
            event.preventDefault()
            try {
                await navigator.clipboard.writeText(char);
                $('.toggle-clip-action').fadeIn(200).delay(1000).fadeOut(200);
            } catch (err) {
                console.error('Failed to copy text: ', err);
                $('.toggle-clip-error').fadeIn(200).delay(1000).fadeOut(200);
            }
        },

        onTypeCertifChange(value) {
            let chmp_editor = ''
            let chmp_editor_id = 0
            if (value == '1') {
                // Loop type_champs and store value into chmp_editor if only the value equals Editeur de texte
                this.type_champs.forEach(type => {
                    if (type.champ == "Editeur de texte") {
                        chmp_editor = type.champ_id+'.'+type.champ
                        chmp_editor_id = type.champ_id
                    }
                });

                for (let i = 0; i < this.info_modele.liste_champs.length; i++) {
                    this.info_modele.liste_champs[i].type = chmp_editor_id
                    this.info_modele.liste_champs[i].tmp_type_champ = chmp_editor

                    this.info_modele.liste_champs[i].can_show_occurence = false
                    this.info_modele.liste_champs[i].occurences = []
                    this.info_modele.liste_champs[i].tmp_existing_occurences = []
                }
            } else {
                for (let i = 0; i < this.info_modele.liste_champs.length; i++) {
                    this.info_modele.liste_champs[i].default_content = ''
                }
            }
        },

        async saveModele() {
            this.err_message = ''
            const isValid = await this.$refs.mdl_exam_form.validate();
            if (!isValid) {
                return;
            }

            const data = {
                type_examen_id: this.type_examen_id,
                user_info: {
                    id: this.user_info.id,
                    nom: this.user_info.name,
                    titre: this.user_info.titre
                },
                modele_id: this.selected_modele.id,
                modele: this.info_modele.nom_modele,
                liste_champs: this.info_modele.liste_champs
            }
            console.log(data);
            
            this.save_loading = true
            store_config.saveModeleExamen(data).then((response) => {
                if (response.success) {
                    this.$refs.n_modele.click()

                    if (this.is_edit === false) {
                        this.$emit('emitRefreshModele')
                    } else {
                        this.$emit('emitRefreshChamp')
                    }
                    
                    this.successToast(response.message)
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Une erreur s'est produite"
            })
        }
    }
}